import React from 'react';
import { useLocation } from '@reach/router';
import { useField } from 'formik';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import FormFieldError from '@components/shared/Form/FormFieldError';
import { InputDescription, P } from '@components/shared/Typography';
import { useCountry } from '@hooks/useCountry';
import { replaceText } from '@utils/handleTextReplacement';
import { getTranslatedHtml } from '@utils/html';

export default function Textarea(props) {
  const { label, description, style, ...rest } = props;
  const [field, meta] = useField(props);
  const { country } = useCountry();
  const location = useLocation();

  return (
    <InputWrapper style={style}>
      {label && <PStyled>{getTranslatedHtml(replaceText(label, country, location))}</PStyled>}
      {description && <InputDescription dangerouslySetInnerHTML={{ __html: replaceText(description, country, location) }} />}
      <TextareaStyled {...field} {...rest} placeholder="" />
      {meta.touched && meta.error && <FormFieldError message={meta.error} />}
    </InputWrapper>
  );
}

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 15px;
`;

interface ITextareaStyled {
  error?: string;
}

const PStyled = styled(P)`
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  margin-top: 0;
  color: ${Colors.navyBlue};

  &:first-child {
    margin-top: 0;
  }
`;

const Description = styled(PStyled)`
  font-weight: 400;
`;

const TextareaStyled = styled.textarea`
  font-family: 'BrownStd';
  font-size: 15px;
  line-height: 24px;
  background: ${Colors.cream};
  color: inherit;
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  padding: 10px 15px;
  margin-bottom: 0;
  margin-top: 10px;
  min-height: 100px;

  width: 100%;
  border-color: ${(props: ITextareaStyled) => (props.error ? '#ea534f' : Colors.gold)};

  &::placeholder {
    padding-top: 2px;
  }
`;
